/** Subscribe to media-query changes, including Safari's legacy listener API. */
export const subscribeToMediaQuery = (
  media: MediaQueryList,
  listener: (event: MediaQueryListEvent) => void,
): (() => void) => {
  if (typeof media.addEventListener === 'function') {
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }
  if (typeof media.addListener === 'function') {
    media.addListener(listener);
    return () => media.removeListener(listener);
  }
  return () => {};
};
